import getApiClient from '../../../shared/api/api-client/getApiClient';
import ApiResultStatus from '../../../shared/api/api-result/ApiResultStatus';
import TrackerMode from '../model/TrackerMode';

export default async function getTrackerMode(): Promise<
  | {
      errorMessage: string;
      status: ApiResultStatus.ERROR;
    }
  | {
      mode: TrackerMode;
      status: ApiResultStatus.OK;
    }
> {
  const client = getApiClient();

  const response = await client.get('/api/mode');

  if (!response.ok) {
    return {
      errorMessage: await response.errorMessage(),
      status: ApiResultStatus.ERROR,
    };
  }

  const json = await response.json<{
    mode: string;
  }>();

  return {
    mode: json.mode === 'demo' ? TrackerMode.DEMO : TrackerMode.NORMAL,
    status: ApiResultStatus.OK,
  };
}
